<template>
	<div class="row">
		<input name="password" type="password" id="password" class="form-control" :class="{error: v$.$error}" placeholder="Enter your password" required @blur="validate" :value="value" @input="updatePassword($event)" />
		<IconErrors v-if="v$.passwordValue.$error" :errors="v$.$errors" />
	</div>
</template>

<script>
import useValidate from "@vuelidate/core"
import {required} from "@vuelidate/validators"
import IconErrors from "../validation/iconErrors.vue"

export default {
	props: ["value"],
	components: {
		IconErrors,
	},
	data() {
		return {
			v$: useValidate(),
			passwordValue: this.value,
		}
	},
	methods: {
		updatePassword($event) {
			this.passwordValue = $event.target.value
			this.$emit("passwordUpdated", this.passwordValue)
		},
		validate() {
			this.v$.$validate()
		},
	},
	validations() {
		return {
			passwordValue: {required},
		}
	},
}
</script>
<style scoped>
label {
	width: auto;
	margin-right: 10px;
}
input#password {
	width: 100%;
}
.error {
	width: 100%;
}
</style>
